export default __webpack_public_path__ + "static/media/490.b77c5728.gif";